<div class="access-deny-container">
  <div class="dialog-box">
    <div class="border-row top-border">
      <div class="corner-left top-left"></div>
      <div class="border-horizontal top-horizontal"></div>
      <div class="corner-right top-right"></div>
    </div>
    <div class="border-row middle-border">
      <div class="border-vertical left-vertical"></div>
      <div class="content-area">
        <div class="message-container">
          <div class="icon-container">
            <div>
              <img src="../../../../assets/icons/stop.gif" alt="Warning Icon" />
            </div>
          </div>
          <div class="text-container">
            <div class="title-text">
              <strong
                >Invalid User ::
                <span class="user-validation" style="color: blue"></span
              ></strong>
            </div>
            <div class="message-text">
              Sorry, this user can not access the link.
            </div>
            <div class="instruction-text">
              Please contact System Administrator to add rights to system if you
              really want to access this link.
            </div>
          </div>
        </div>
      </div>
      <div class="border-vertical right-vertical"></div>
    </div>
    <div class="border-row bottom-border">
      <div class="corner-left bottom-left"></div>
      <div class="border-horizontal bottom-horizontal"></div>
      <div class="corner-right bottom-right"></div>
    </div>
  </div>
</div>
<div class="button-container">
  <button type="button" class="btn btn-secondary" (click)="goBack()">
    Back
  </button>
</div>
